import { render, staticRenderFns } from "./coverImg.vue?vue&type=template&id=68de21e5&scoped=true&"
import script from "./coverImg.vue?vue&type=script&lang=js&"
export * from "./coverImg.vue?vue&type=script&lang=js&"
import style0 from "./coverImg.vue?vue&type=style&index=0&id=68de21e5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de21e5",
  null
  
)

export default component.exports